import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Placeholder from 'flarum/common/components/Placeholder';
import EventCard from './EventCard';
export default class MatchesTab extends Component {
  selectedSeason = 'all';
  selectedWeek = 'all';
  selectedTeam = 'all';
  selectedStatus = 'all';
  loading = false;
  events = [];
  hasMore = false;
  limit = 10;
  pickLoading = new Set();
  oninit(vnode) {
    super.oninit(vnode);
    const seasons = app.store.all('pickem-seasons');
    if (seasons.length === 1) {
      this.selectedSeason = seasons[0].id();
    }
    this.loadEvents(true);
  }
  buildFilters() {
    const filters = {};
    const weekIds = [];
    if (this.selectedWeek !== 'all') {
      filters.week = this.selectedWeek;
    } else if (this.selectedSeason !== 'all') {
      const weeks = app.store.all('pickem-weeks').filter(week => week.seasonId() == this.selectedSeason);
      weekIds.push(...weeks.map(week => week.id()));
      weekIds.push('null');
      filters.week = weekIds.join(',');
    }
    if (this.selectedTeam !== 'all') {
      filters.team = this.selectedTeam;
    }
    if (this.selectedStatus !== 'all') {
      filters.status = this.selectedStatus;
    }
    return filters;
  }
  loadEvents(clear = false) {
    this.loading = true;
    m.redraw();
    const offset = clear ? 0 : this.events.length;
    const filters = this.buildFilters();
    app.store.find('pickem-events', {
      include: 'homeTeam,awayTeam,week',
      filter: filters,
      sort: '-matchDate',
      page: {
        limit: this.limit,
        offset: offset
      }
    }).then(results => {
      if (clear) {
        this.events = results;
      } else {
        this.events = [...this.events, ...results];
      }
      this.hasMore = results.length >= this.limit;
      this.fetchPicksForEvents(results);
    }).catch(error => {
      console.error(error);
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  fetchPicksForEvents(events) {
    if (!app.session.user || !app.forum.attribute('pickem.makePicks')) return;
    const currentPicks = this.attrs.picks || {};
    const eventsToFetch = events.filter(e => !currentPicks[String(e.id())]);
    if (eventsToFetch.length === 0) return;
    const eventIds = eventsToFetch.map(e => e.id()).join(',');
    app.store.find('pickem-picks', {
      filter: {
        user: app.session.user.id(),
        event: eventIds
      }
    }).then(results => {
      if (Array.isArray(results) && results.length > 0) {
        const newPicks = results.reduce((acc, pick) => {
          const eId = pick.event() ? pick.event().id() : pick.attribute('eventId');
          if (eId) acc[String(eId)] = pick;
          return acc;
        }, {});
        const merged = {
          ...this.attrs.picks,
          ...newPicks
        };
        this.attrs.onPickChange(merged);
        m.redraw();
      }
    });
  }
  async makePick(eventId, outcome) {
    const eventIdStr = String(eventId);
    const existingPick = this.attrs.picks[eventIdStr];
    this.pickLoading.add(eventId);
    m.redraw();
    try {
      const updateParent = newPickVal => {
        const newPicks = {
          ...this.attrs.picks
        };
        if (newPickVal === null) {
          delete newPicks[eventIdStr];
        } else {
          newPicks[eventIdStr] = newPickVal;
        }
        this.attrs.onPickChange(newPicks);
      };
      if (existingPick && existingPick.selectedOutcome() === outcome) {
        await existingPick.delete();
        updateParent(null);
        app.alerts.show({
          type: 'success'
        }, app.translator.trans('huseyinfiliz-pickem.lib.messages.deleted'));
      } else if (existingPick) {
        const updated = await existingPick.save({
          selectedOutcome: outcome
        });
        updateParent(updated);
        app.alerts.show({
          type: 'success'
        }, app.translator.trans('huseyinfiliz-pickem.lib.messages.saved'));
      } else {
        const newPick = app.store.createRecord('pickem-picks');
        const saved = await newPick.save({
          eventId: eventId,
          selectedOutcome: outcome
        });
        updateParent(saved);
        app.alerts.show({
          type: 'success'
        }, app.translator.trans('huseyinfiliz-pickem.lib.messages.saved'));
      }
    } catch (error) {
      console.error('Pick error:', error);
      if (error.response && error.response.errors && error.response.errors[0]) {
        app.alerts.show({
          type: 'error'
        }, error.response.errors[0].detail);
      } else {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('huseyinfiliz-pickem.lib.messages.invalid_outcome'));
      }
    } finally {
      this.pickLoading.delete(eventId);
      m.redraw();
    }
  }
  view() {
    const allSeasons = app.store.all('pickem-seasons');
    const allTeams = app.store.all('pickem-teams');
    const hasEvents = this.events.length > 0;
    let availableWeeks = [];
    if (this.selectedSeason !== 'all') {
      availableWeeks = app.store.all('pickem-weeks').filter(week => week.seasonId() == this.selectedSeason).sort((a, b) => {
        const numA = parseInt(String(a.weekNumber() || 0));
        const numB = parseInt(String(b.weekNumber() || 0));
        return numA - numB;
      });
    }
    const currentPicks = this.attrs.picks || {};
    return m("div", null, m("div", {
      className: "EventsTab-filters PickemPage-filters"
    }, m("div", {
      className: "FilterGroup"
    }, m("label", null, m("i", {
      className: "fas fa-calendar-alt"
    }), m("span", null, app.translator.trans('huseyinfiliz-pickem.lib.common.season'))), m("select", {
      className: "FormControl",
      value: this.selectedSeason,
      onchange: e => {
        this.selectedSeason = e.target.value;
        this.selectedWeek = 'all';
        this.loadEvents(true);
      }
    }, m("option", {
      value: "all"
    }, app.translator.trans('huseyinfiliz-pickem.lib.filters.all')), allSeasons.map(season => m("option", {
      value: season.id()
    }, season.name())))), m("div", {
      className: "FilterGroup"
    }, m("label", null, m("i", {
      className: "fas fa-calendar-week"
    }), m("span", null, app.translator.trans('huseyinfiliz-pickem.lib.common.week'))), m("select", {
      className: "FormControl",
      value: this.selectedWeek,
      disabled: this.selectedSeason === 'all' || availableWeeks.length === 0,
      onchange: e => {
        this.selectedWeek = e.target.value;
        this.loadEvents(true);
      }
    }, m("option", {
      value: "all"
    }, app.translator.trans('huseyinfiliz-pickem.lib.filters.all')), availableWeeks.map(week => m("option", {
      value: week.id()
    }, week.name())))), m("div", {
      className: "FilterGroup"
    }, m("label", null, m("i", {
      className: "fas fa-users"
    }), m("span", null, app.translator.trans('huseyinfiliz-pickem.lib.common.team'))), m("select", {
      className: "FormControl",
      value: this.selectedTeam,
      onchange: e => {
        this.selectedTeam = e.target.value;
        this.loadEvents(true);
      }
    }, m("option", {
      value: "all"
    }, app.translator.trans('huseyinfiliz-pickem.lib.filters.all')), allTeams.map(team => m("option", {
      value: team.id()
    }, team.name())))), m("div", {
      className: "FilterGroup"
    }, m("label", null, m("i", {
      className: "fas fa-filter"
    }), m("span", null, app.translator.trans('huseyinfiliz-pickem.lib.common.status'))), m("select", {
      className: "FormControl",
      value: this.selectedStatus,
      onchange: e => {
        this.selectedStatus = e.target.value;
        this.loadEvents(true);
      }
    }, m("option", {
      value: "all"
    }, app.translator.trans('huseyinfiliz-pickem.lib.filters.all')), m("option", {
      value: "scheduled"
    }, app.translator.trans('huseyinfiliz-pickem.lib.status.scheduled')), m("option", {
      value: "closed"
    }, app.translator.trans('huseyinfiliz-pickem.lib.status.closed')), m("option", {
      value: "finished"
    }, app.translator.trans('huseyinfiliz-pickem.lib.status.finished'))))), !hasEvents && !this.loading ? m(Placeholder, {
      text: app.translator.trans('huseyinfiliz-pickem.lib.messages.no_matches')
    }) : m("div", {
      className: "MatchesList"
    }, this.events.map(event => {
      const eventIdStr = String(event.id());
      const pick = currentPicks[eventIdStr];
      const isLoading = this.pickLoading.has(Number(event.id()));
      return m(EventCard, {
        event: event,
        pick: pick,
        onMakePick: (eventId, outcome) => this.makePick(eventId, outcome),
        isLoading: isLoading
      });
    })), this.hasMore && m("div", {
      className: "LoadMore"
    }, m(Button, {
      className: "Button Button--primary",
      loading: this.loading,
      onclick: () => this.loadEvents(false)
    }, app.translator.trans('huseyinfiliz-pickem.lib.buttons.load_more'))));
  }
}
flarum.reg.add('huseyinfiliz-pickem', 'forum/components/MatchesTab', MatchesTab);